import * as React from "react";
import { useTranslation } from "react-i18next";
import { DashboardElement } from "./DashboardElement";
import { canEditFiles, hasRight } from "../../shared";
import { ACCESS_RIGHTS } from "../../constants";
import { DashboardButton } from "./DashboardButton";

const SettingsElement = () => {
  const [t] = useTranslation();
  const { enable_appointment_scheduler } = window.ITREF.config;

  return (
    <DashboardElement title={t("settings")} boxColor="grey">
      {(hasRight(ACCESS_RIGHTS.user_overview) ||
        hasRight(ACCESS_RIGHTS.confirm_users)) && (
        <DashboardButton
          title={t("dashboard.buttons.member_overview")}
          href="/members"
          icon="user-md"
        />
      )}
      {hasRight(ACCESS_RIGHTS.invite_ttks) && (
        <DashboardButton
          title={t("dashboard.buttons.permission")}
          href="/ttks"
          icon="hospital-user"
        />
      )}
      {hasRight(ACCESS_RIGHTS.calendar) && enable_appointment_scheduler && (
        <DashboardButton
          title={t("dashboard.buttons.event_series")}
          href="/event_series"
          icon="calendar-alt"
        />
      )}
      {hasRight(ACCESS_RIGHTS.calendar) && enable_appointment_scheduler && (
        <DashboardButton
          key="calendar-index"
          title={t("dashboard.buttons.calendars")}
          href="/calendars"
          icon="calendar"
        />
      )}
      {canEditFiles() && (
        <DashboardButton
          key="file-index"
          title={t("files.folders")}
          href="/files"
          icon="file-upload"
        />
      )}
    </DashboardElement>
  );
};

export default SettingsElement;
